export interface Readiness {
  key: string;
  label: string;
  ok: boolean;
  detail: string;
}

export interface Funnel {
  enabled: boolean;
  ready: boolean;
  enablePhrase: string;
  readiness: Readiness[];
}

export interface Capabilities {
  canTouchProduction: boolean;
  canManageFirewall: boolean;
  canChangeFunnel: boolean;
}

export interface SystemView {
  id: string;
  name: string;
  hostname: string;
  role: string | null;
  address: string | null;
}

export interface GroupView {
  id: string;
  name: string;
  description: string | null;
  memberIds: string[];
  ruleCount: number;
}

export interface RuleView {
  id: string;
  action: 'ALLOW' | 'DENY';
  protocol: 'tcp' | 'udp' | 'any';
  portLabel: string;
  portStart: number | null;
  portEnd: number | null;
  surface: 'HOST' | 'DOCKER';
  scope: 'SUBNET' | 'SERVER' | 'GROUP';
  targetId: string | null;
  targetName: string;
  source: 'manual' | 'baseline';
  baselineKey: string | null;
  baselineTitle: string | null;
  sources: string[];
  description: string | null;
  enabled: boolean;
  isSystem: boolean;
  businessJustification: string | null;
  expiresAt: string | null;
  reviewBy: string | null;
  expired: boolean;
  reviewOverdue: boolean;
  applied: boolean;
  createdBy: string | null;
  updatedAt: string;
}

export interface BaselineView {
  key: string;
  title: string;
  plain: string;
  rationale: string;
  action: 'ALLOW' | 'DENY';
  protocol: 'tcp' | 'udp';
  port: number;
  sourcesMode: 'none' | 'fixed' | 'required';
  fixedSources: string[];
  frameworks: string[];
  allowedOnSubnet: boolean;
  allowedOnGroups: boolean;
  allowedSystemIds: string[];
  states: {
    subnet: boolean;
    groups: Record<string, boolean>;
    systems: Record<string, boolean>;
  };
}

export interface PendingApply {
  applyId: string;
  status: 'PENDING' | 'COMMITTED' | 'ROLLED_BACK' | 'EXPIRED' | 'FAILED';
  expiresAt: string;
  timeoutSec: number;
  lines: string[];
}

export interface FirewallOverview {
  subnet: string;
  chain: string;
  host: {
    hostname: string | null;
    readable: boolean | null;
    lastReadAt: string | null;
    inSync: boolean;
    missing: string[];
    extra: string[];
    hasReading: boolean;
  };
  systems: SystemView[];
  groups: GroupView[];
  rules: RuleView[];
  baseline: BaselineView[];
  warnings: string[];
  pendingApply: PendingApply | null;
}

export interface Preview {
  applyable: boolean;
  lines: string[];
  added: string[];
  removed: string[];
  warnings: string[];
}

export function errorText(err: unknown): string {
  return err instanceof Error ? err.message : 'Request failed';
}
